module.exports = __webpack_public_path__ + "static/media/studio_electric_forklift_truck_me_318_manitou_001.31dfd70c.png";